import React from "react";
import "./reset.css";
import classes from "./layout.module.scss";
import Header from "../header/header";
import Error from "../../containers/error/error404.js";
import Home from "../../containers/home/home.js";
import RiverDiagram from "../../containers/riverDiagram/riverDiargam";
import { Switch, Route } from "react-router-dom";
import Rivers from "../../containers/rivers/rivers";
import Chemicals from "../../containers/chemicals/chemicals";

function Layout() {
  return (
    <div className={classes.wrapper}>
      <Header />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/chemicals">
          <Chemicals />
        </Route>
        <Route exact path="/rivers">
          <Rivers />
        </Route>
        <Route exact path="/riverDiagram">
          <RiverDiagram />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </div>
  );
}

export default Layout;
